import { Navigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

export default function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()

  if (loading) return null // o un spinner

  return isAuthenticated ? children : <Navigate to="/login" />
}
